import {
    convertPerQuestionDiagramToTotal,
    convertPerQuestionNestedBooleanMapToPerQuestion,
} from '../../../../utils/model-progress.helper'
import baseApi from '../../base.api'

export const onUpdatePatternQueryStarted = async (arg, { dispatch, queryFulfilled }) => {
    try {
        await queryFulfilled
        dispatch(
            baseApi.util.updateQueryData(
                'fetchProgress',
                {
                    token: arg.token,
                    versionId: arg.versionId,
                },
                draft => {
                    const patternDone = Boolean(
                        arg.feedback.trim() && arg.description.trim() && (arg.grade === 0 || arg.grade),
                    )

                    draft.originalModel.patterns[arg.questionId][arg.id] = patternDone

                    const questionPatterns = convertPerQuestionNestedBooleanMapToPerQuestion(
                        draft.originalModel.patterns,
                    )

                    draft.patterns = questionPatterns
                    draft.totalPatterns = convertPerQuestionDiagramToTotal(questionPatterns)
                },
            ),
        )
    } catch (error) {
        console.error('Error updating question:', error)
    }
}
